import React, { useEffect } from "react";

import {
  IndexRedirect,
  IndexRoute,
  Redirect,
  Router,
  Route,
  browserHistory
} from "react-router";
import Navigation from "./components/Navigation";
import ImportList from "./components/ImportList";
import Products from "./components/Products";
import SettingsComponents from "./components/Settings";
import Privacy from "./components/Privacy";
import Terms from "./components/Terms";
import OrderList from "./components/OrderList";
import requireAuth from "./components/RequireAuth";
import requireShop from "./components/RequireShop";
import Login from "./components/Login";
import Register from "./components/Register";
import PlanRedirect from "./components/PlanRedirect";
import DataProcessingAddendum from "./components/DataProcessingAddendum";
import { QueryParamProvider } from "use-query-params";

// New Dropshipper App
import FinancialDashboard from "./newDropshipperApp/pages/FinancialDashboard";
import SpocketDeals from "./newDropshipperApp/pages/SpocketDeals";
import Signup from "./newDropshipperApp/pages/Signup";
import Academy from "./newDropshipperApp/pages/Academy";
import Paypal from "./newDropshipperApp/pages/Paypal";
import Suppliers from "./newDropshipperApp/pages/Suppliers";
import allNotifications from "./newDropshipperApp/pages/AllNotifications";
import StoreBuilder from "./newDropshipperApp/pages/StoreBuilder";
import Search from "./newDropshipperApp/pages/Search";
import Aliscraper from "./newDropshipperApp/pages/Aliscraper";
import Registration from "./newDropshipperApp/pages/Registration";
import CreateAccount from "./newDropshipperApp/pages/CreateAccount";
import Upgrade from "./newDropshipperApp/pages/Upgrade";

// Shared Components
import { Maintenance } from "shared_components";

// Utils
import initTrackingURL from "./newDropshipperApp/utils/trackUrl";

const QueryParamProviderRoute = ({ children, router, location }) => {
  return (
    <QueryParamProvider history={router} location={location}>
      {children}
    </QueryParamProvider>
  );
};

const Routes = props => {
  useEffect(() => initTrackingURL());

  return (
    <Router history={browserHistory}>
      <Route component={QueryParamProviderRoute}>
        <Route path="register" component={Register} />
        <Route path="login" component={Login} />
        <Route path="registration" component={Registration} />
        <Route path="signup" component={Signup} />
        <Route path="create-account" component={CreateAccount} />
        <Route path="maintenance" component={Maintenance} />
        <Route path="upgrade" component={Upgrade} />

        <Redirect from="/" to="search" />

        <Route path="/" component={requireAuth(Navigation)}>
          <IndexRoute component={requireAuth(Search)} />
          <Route path="plan_redirect" component={PlanRedirect} />
          <Route path="search" component={Search} />
          <Route path="import" component={requireShop(ImportList)} />
          <Route path="products" component={requireShop(Products)} />
          <Route path="settings" component={SettingsComponents.Settings}>
            <IndexRedirect to="plan" />
            <Route path="account" component={SettingsComponents.AccountTab} />
            <Route path="invoice" component={SettingsComponents.InvoiceTab} />
            <Route path="security" component={SettingsComponents.SecurityTab} />
            <Route path="pricing" component={SettingsComponents.PricingTab} />
            <Route path="plan" component={SettingsComponents.PlansTab} />
            <Route path="payment" component={SettingsComponents.PaymentTab} />
            {/* <Route path="get-paid" component={SettingsComponents.GetPaid} /> */}
          </Route>
          <Route path="privacy" component={Privacy} />
          <Route path="terms" component={Terms} />
          <Route
            path="data-processing-addendum"
            component={DataProcessingAddendum}
          />
          <Route path="orders" component={requireShop(OrderList)} />

          {/* New Dropshipper  App*/}
          <Route path="store-builder" component={StoreBuilder} />
          <Route path="financial-dashboard" component={FinancialDashboard} />
          <Route path="spocket-deals" component={requireShop(SpocketDeals)} />
          <Route path="academy" component={requireShop(Academy)} />
          <Route path="settings/paypal/payment_success" component={Paypal} />
          <Route path="settings/paypal/payment_cancel" component={Paypal} />
          <Route path="suppliers" component={Suppliers}>
            <Route path=":supplierAlias" component={Suppliers} />
          </Route>
          <Route path="notification-center" component={allNotifications} />
          <Route path="aliscraper" component={Aliscraper} />
        </Route>
      </Route>
    </Router>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js